import { useQuery } from '@tanstack/react-query';

import { fetchShipmentDefaultAddress } from '../data-provider/shipment-default-address';
import type { GetShipmentDefaultAddressRequestParams } from '../data-provider/shipment-default-address/api';

export const useGetShipmentDefaultAddress = (params: GetShipmentDefaultAddressRequestParams) => {
  return useQuery({
    enabled: Boolean(params.branchKey) && Boolean(params.shipmentTypeValue),
    queryFn: () => fetchShipmentDefaultAddress(params),
    queryKey: ['shipment-default-address', params.branchKey, params.shipmentTypeValue],
    // biome-ignore lint/style/noMagicNumbers: 1 hour
    staleTime: 1000 * 60 * 60,
  });
};
